import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

declare var google: any;

@Component({
  selector: 'app-maps-detail',
  templateUrl: './maps-detail.component.html',
  styleUrls: ['./maps-detail.component.scss']
})
export class MapsDetailComponent implements OnInit {

  public organization: any = {};
  public errorMessage: string = '';
  public infoContent: string = '';

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  markerPosition: google.maps.LatLngLiteral = null;
  center: google.maps.LatLngLiteral = { lat: 40.4166400, lng: -3.7032700 };
  zoom = 6;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.organization = this.config.data.organization;
    this.organization.errorMessage = "";

    setTimeout(() => {
      this.initMarker();
    }, 10);
  }

  async initMarker() {
    if (!this.organization.lat || !this.organization.lng) {
      // Si no hay lat/lng, geocodifica la dirección
      await this.geocodePosition(this.organization);
    }
    // Si sigue sin lat/lng, se pone un valor por defecto
    if (!this.organization.lat || !this.organization.lng) {
      this.organization.lat = 40.4166400;
      this.organization.lng = -3.7032700;
    }
    this.markerPosition = { lat: this.organization.lat, lng: this.organization.lng };
    this.center = { lat: this.organization.lat, lng: this.organization.lng };
    this.zoom = 16;
  }

  geocodePosition(organization: any): Promise<void> {
    return new Promise((resolve) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { address: `${organization.address || ''} ${organization.postal_code || ''} ${organization.city || ''}` },
        (results, status) => {
          if (status === 'OK' && results[0]) {
            organization.lat = results[0].geometry.location.lat();
            organization.lng = results[0].geometry.location.lng();
            organization.errorMessage = '';
          } else {
            organization.lat = 40.4166400;
            organization.lng = -3.7032700;
            organization.errorMessage = this.translateService.instant("component.maps.cant_add_marker_in_position") +
              ` ${organization.address || ''} ${organization.postal_code || ''} ${organization.city || ''}`;
          }
          resolve();
        }
      );
    });
  }

  markerDragEnd(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.organization.lat = event.latLng.lat();
      this.organization.lng = event.latLng.lng();
      this.markerPosition = { lat: this.organization.lat, lng: this.organization.lng };
    }
  }

  save() {
    this.dynamicDialogRef.close(this.organization);
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
}
